import { withI18n } from 'react-i18next';
import EmailInvoicesApplyCreditModel from './EmailInvoicesApplyCreditModel';

export const pureComponent = EmailInvoicesApplyCreditModel;
export default withI18n()(EmailInvoicesApplyCreditModel);
